import $ from 'jquery'

const initTooltips = () => {
  $('.lr-tooltip').tooltip('enable')
}

export default initTooltips
